/* NoResultViewStyles.ts generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _14 = "._y3gn1h6o{text-align:center}";
const _13 = "._1bsb1wug{width:auto}";
const _12 = "._4t3i1osq{height:100%}";
const _11 = "._1bsb1osq{width:100%}";
const _10 = "._4t3i1lit{height:10pc}";
const _9 = "@media (min-width:48rem){._19wg1bcc{gap:var(--ds-space-250)}}";
const _8 = "._zulpv47k{gap:var(--ds-space-250,20px)}";
import { media } from '@atlaskit/primitives/responsive';
const _7 = "@media (min-width:64rem){._1yag172p{padding:75pt var(--ds-space-0)}._pdlm1bcc{gap:var(--ds-space-250)}}";
const _6 = "._1yt4i1hg{padding:var(--ds-space-800) var(--ds-space-0)}";
const _5 = "._zulpl6l0{gap:var(--ds-space-300)}";
const _4 = "._1bah1h6o{justify-content:center}";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
export const NoResultViewContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulpl6l0 _1yt4i1hg _1yag172p _pdlm1bcc", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  NoResultViewContainer.displayName = 'NoResultViewContainer';
}
export const NoResultViewContent = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _8, _9]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulpv47k _19wg1bcc", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  NoResultViewContent.displayName = 'NoResultViewContent';
}
export const SearchErrorImageContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _4, _10, _11]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _1bah1h6o _4t3i1lit _1bsb1osq", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SearchErrorImageContainer.displayName = 'SearchErrorImageContainer';
}
export const SearchErrorImage = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_12, _13]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_4t3i1osq _1bsb1wug", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SearchErrorImage.displayName = 'SearchErrorImage';
}
export const TextContainer = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_14]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_y3gn1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  TextContainer.displayName = 'TextContainer';
}